import React from "react";
import { Button, IconButton, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import WITHDRAWN_IMAGE from "../../../images/Banner/withdrawn.jpg";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

/** Zoom / pan view of the selected image. */
export default function ZoomDialog({
  handleClose,
  handleMouseDown,
  handleMouseMove,
  handleMouseUp,
  handleTouchMove,
  handleTouchStart,
  handleZoomIn,
  handleZoomOut,
  isDragging,
  isMobile,
  isWidraw,
  position,
  resetZoom,
  scale,
  selectedImage1,
  zoom,
}) {
  return (
    <Dialog
      className="single-product-bell-mt"
      open={zoom}
      onClose={() => {
        resetZoom();
        handleClose();
      }}
      // Eto ang magic para sa mobile full screen
      fullScreen={isMobile}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 3, // Alisin ang kanto sa mobile
          backgroundColor: "#fff",
          boxShadow: isMobile ? 0 : 6,
          overflow: "hidden",
          margin: isMobile ? 0 : 2, // Siguradong walang gap sa gilid pag mobile
        },
      }}
    >
      <DialogContent
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchMove={handleTouchMove}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // Full height sa mobile, 80vh sa desktop
          height: isMobile ? "100vh" : "80vh",
          p: isMobile ? 0 : 2.5, // Alisin ang padding sa mobile para mas malaki image
          backgroundColor: isMobile ? "#f9f9f9" : "#f9f9f9", // Black background sa mobile (pro look)
          cursor:
            scale > 1 ? (isDragging ? "grabbing" : "grab") : "default",
          position: "relative",
        }}
      >
        <div
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
          style={{
            width: "100%",
            height: "100%",
            backgroundImage: `url(${
              isWidraw === 1 ? WITHDRAWN_IMAGE : selectedImage1
            })`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
            transform: `scale(${scale}) translate(${
              position.x / scale
            }px, ${position.y / scale}px)`,
            transition: isDragging ? "none" : "transform 0.3s ease",
            willChange: "transform",
            userSelect: "none",
            pointerEvents: "auto",
          }}
        />
      </DialogContent>


      <DialogActions
        sx={{
          justifyContent: "space-between",
          px: 3,
          py: 1.5,
          backgroundColor: "#fff",
          // Sa mobile, pwedeng gawing sticky sa ilalim
          position: isMobile ? "fixed" : "relative",
          bottom: 0,
          width: "100%",
          zIndex: 10,
          borderTop: "1px solid #eee",
        }}
      >
        <Stack direction="row" spacing={1}>
          <IconButton onClick={handleZoomOut} disabled={scale <= 1}>
            <ZoomOutIcon />
          </IconButton>
          <Button
            onClick={resetZoom}
            disabled={scale === 1}
            sx={{
              color: "#000",
              textTransform: "none",
              fontFamily: "Bell MT, Georgia, Times New Roman, serif",
            }}
          >
            Reset
          </Button>
          <IconButton onClick={handleZoomIn} disabled={scale >= 3}>
            <ZoomInIcon />
          </IconButton>
        </Stack>

        <Button
          variant="contained"
          onClick={() => {
            resetZoom();
            handleClose();
          }}
          sx={{
            bgcolor: "#000",
            color: "#fff",
            borderRadius: 0,
            "&:hover": { bgcolor: "#333" },
            px: 3,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
